import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import { SupporterContactInfoModel } from '../../../auth/models/supporter-contact-info.model';

@Component({
  selector: 'tart-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent {
  icon: 'error' | 'warning' | 'info' | 'success' | 'close';
  title: string;
  message: string;
  messageDetail: string;
  supporterContactInfo: SupporterContactInfoModel;
  errorMessage: string;
  errorsList: string[];
  errorsListTitle = '';
  dialogMode: 'default' | 'simple-warning' = 'default';
  btnTitle = 'تایید';
  hideConfirmBtn = false;

  constructor(private dialogRef: NbDialogRef<any>) { }
  isExpanded = false;

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  close() {
    this.dialogRef.close();
  }

}
